module.exports = __webpack_public_path__ + "img/password-pc.061075b3.svg";